import React from 'react';
import PropTypes from 'prop-types';
import { pure } from 'recompose';
import classNames from 'classnames';

import spinnerCss from './spinnerLoader.scss';


const SVG = (props) => {
  const { styles = {}, icon, className, onDragOver, onDragEnter, onDragLeave, onDrop, onClick, title, height, width, size, ...rest } = props;

  // ATAI-59: the loading spinner is the approved CSS `l4` animation (design ATAI-54), not an
  // SVG symbol — a box-shadow animation can't be expressed as one. Rendered here so every
  // `<SVG icon="spinner" />` usage gets it. Size: an explicit width/size/height sets `--s`;
  // otherwise it defaults to 1em (text-sized), so in-button/inline spinners look right and
  // nothing renders oversized. Per-area sizes are tuned in each area's stylesheet.
  if (icon === 'spinner') {
    const s = width || size || height;
    const spinnerStyle = s ? { ...styles, width: `${s}px`, height: `${s}px` } : styles;
    return (
      <span
        {...{ onDragOver, onDragEnter, onDragLeave, onDrop, onClick }}
        style={spinnerStyle}
        className={classNames('icon-spinner', spinnerCss.loader, className)}
      />
    );
  }

  const use = icon ? <use xlinkHref={`#${icon}`} /> : null;

  if (height || size) styles.height = `${height || size}px`;
  if (width || size) styles.width = `${width || size}px`;

  return (
    <svg {...{ onDragOver, onDragEnter, onDragLeave, onDrop, onClick }} {...rest} style={styles} className={classNames(`icon-${icon}`, className)}>
      {!title ? null : <title>{title}</title>}
      {use}
    </svg>
  );
};

SVG.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  onDragOver: PropTypes.func,
  onDragEnter: PropTypes.func,
  onDragLeave: PropTypes.func,
  onDrop: PropTypes.func,
  onClick: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  size: PropTypes.number,
};

export default pure(SVG);
